export default function initPageHeader() {
  const header = document.querySelector(".page-header");

  const browserWidth = document.body.offsetWidth;
  const matchesNavigation = browserWidth >= 1200;

  const addRemoveScrollClass = () => {
    if (header) {
      let globalAlertVisible;
      if (matchesNavigation) {
        globalAlertVisible = false;
      } else {
        globalAlertVisible = !document
          .querySelector(".mobile-header__alert")
          .classList.contains("--hidden");
      }

      globalAlertVisible
        ? header?.classList.add("--with-alert")
        : header?.classList.remove("--with-alert");
    } else {
      return;
    }
  };

  window.addEventListener("DOMContentLoaded", addRemoveScrollClass);
  window.addEventListener("scroll", addRemoveScrollClass);
}
